import { useCallback } from "react";
import { RTEContent } from "shared/components";
import { BoldText, MutedText } from "shared/styles";

export const useUserPreferenceRenderLine = () => {
  const renderLabel = useCallback((label: string) => <BoldText>{label}</BoldText>, []);

  const renderValue = useCallback(
    (value: string) => (
      <MutedText>
        <span dangerouslySetInnerHTML={{ __html: value }} />
      </MutedText>
    ),
    []
  );

  const renderRTE = useCallback((value: string) => <RTEContent content={value} />, []);

  const renderLine = useCallback(
    (label: string, value?: string | null, rte?: boolean) => {
      if (!value) return null;

      return (
        <li>
          {renderLabel(label)} {rte ? renderRTE(value) : renderValue(value)}
        </li>
      );
    },
    [renderLabel, renderValue, renderRTE]
  );

  return { renderLine };
};
